import * as React from 'react';
import { ID365MarketingFromViewProps } from './d365-marketing-from';

// tslint:disable-next-line: no-typeof-undefined
const IsClientSide = () => !!(typeof window !== 'undefined' && window.document && window.document.createElement);

export default (props: ID365MarketingFromViewProps) => {
    const config = props.config;
    const divRef = React.useRef<HTMLDivElement>(null);
    const [initialized, setInitialized] = React.useState(false);

    const isClientSide = IsClientSide();
    const formBlockId = config.formBlockId;

    React.useEffect(() => {
        const div = divRef.current;
        if (!initialized && isClientSide && div && formBlockId) {
            setInitialized(true);

            const childDiv = document.createElement('div');
            childDiv.setAttribute('data-form-block-id', formBlockId);
            div.appendChild(childDiv);
        }
    }, [isClientSide, initialized, formBlockId, divRef]);

    return (
        <div className={config.className}>
            <div ref={divRef} />
        </div>
    );
};
